import { render } from "./EditAddedItemQuotation.vue?vue&type=template&id=072eca4c"
import script from "./EditAddedItemQuotation.vue?vue&type=script&lang=js"
export * from "./EditAddedItemQuotation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__